import { EventEmitter, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TableColumns } from '../../types/table-columns';
import { ResourceType } from '../../types/resource-type';
var DataTableComponent = /** @class */ (function () {
    function DataTableComponent() {
        this.enablePagination = true;
        this.enableFiltering = false;
        this.canAdd = true;
        this.canEdit = true;
        this.canRemove = true;
        this.selectable = false;
        this.filterLabel = 'Filter';
        this.showIndex = false;
        /**
         * Used to emit the row in which the user clicks the 3 dots
         */
        this.activeElement = new EventEmitter();
        this.edit = new EventEmitter();
        this.remove = new EventEmitter();
        this.add = new EventEmitter();
        this.selectElement = new EventEmitter();
    }
    Object.defineProperty(DataTableComponent.prototype, "data", {
        set: function (data) {
            if (data) {
                this.dataSource = new MatTableDataSource(data);
                this.dataSource.sort = this.sort;
                if (this.enablePagination) {
                    this.dataSource.paginator = this.paginator;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    DataTableComponent.prototype.ngOnInit = function () {
        this.displayedColumns = Object.keys(this.tableColumns);
        if (this.showIndex) {
            this.displayedColumns = ['index'].concat(this.displayedColumns);
        }
    };
    DataTableComponent.prototype.getArrayKey = function (column, columnOptions) {
        return columnOptions.arrayColumn ? columnOptions.arrayColumn : column;
    };
    DataTableComponent.prototype.applyFilter = function (filterValue) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    };
    DataTableComponent.prototype.onSelect = function (row) {
        if (this.selectable) {
            this.selectElement.emit(row);
        }
    };
    return DataTableComponent;
}());
export { DataTableComponent };
